/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import PropTypes from "prop-types";
import { Icon, ListView, PullToRefresh } from "antd-mobile";
import { FormattedMessage } from "react-intl";
import EmptyQueue from "../EmptyQueue";
import QueueFoodGroup from "../QueueFoodGroup";
import "./index.css";

class QueueListing extends Component {
  constructor(props) {
    super(props);
  }

  getPullToRefresh = () => {
    const { onRefresh, isRefreshing } = this.props;

    return (
      <PullToRefresh
        damping={70}
        refreshing={isRefreshing}
        onRefresh={() => onRefresh && onRefresh()}
        indicator={{
          activate: <FormattedMessage id="app.pull_to_refresh.activate" />,
          release: (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Icon type="loading" size="xxs" />
              <span style={{ marginLeft: "5px", fontSize: "0.8em" }}>
                <FormattedMessage id="app.loading" />
                ...
              </span>
            </div>
          ),
          finish: <FormattedMessage id="app.pull_to_refresh.finishText" />
        }}
      />
    );
  };

  render() {
    const { items, onRefresh, auth, history } = this.props;
    const dataSource = new ListView.DataSource({
      rowHasChanged: (row1, row2) => row1 !== row2
    });

    if (items && items.type && items.type === "empty") {
      return (
        <EmptyQueue
          auth={auth}
          onRefresh={onRefresh}
          onLogin={() => history.push("/auth/login")}
        />
      );
    }

    return (
      <ListView
        className={"queue-listing"}
        ref={el => (this.lv = el)}
        dataSource={dataSource.cloneWithRows(items)}
        renderRow={data => <QueueFoodGroup groupItem={data} />}
        pageSize={10}
        scrollRenderAheadDistance={500}
        onEndReachedThreshold={800}
        onEndReached={this.onEndReached}
        pullToRefresh={this.getPullToRefresh()}
        style={{
          minHeight: "100%",
          width: "100%"
        }}
      />
    );
  }
}

QueueListing.propTypes = {
  showNavbar: PropTypes.func.isRequired,
  showTabbar: PropTypes.func.isRequired,
  navbarConfig: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  auth: PropTypes.bool.isRequired,
  items: PropTypes.array.isRequired,
  onRefresh: PropTypes.func,
  isRefreshing: PropTypes.bool
};

QueueListing.defaultProps = {};

export default QueueListing;



// WEBPACK FOOTER //
// ./src/components/QueueListing/index.js